import service from '../allservices.jsx'
import platform from '../platforms.jsx'
import { getClientId, getClientSecret,buildClientHeader } from '../../utils/clientAuth';
import uuidv4 from 'uuid/v4';

export function publicKey(actionCallback) {
    let appid = localStorage.getItem('pform') === 'AU' ? 'klickexau' : 'klickex'

    let plink =  localStorage.getItem('pform')==='AU'? process.env.REACT_APP_SERVICEURL_AU : process.env.REACT_APP_SERVICEURL_NZ 
    console.log("plink is " , plink)
    let gid = getClientId();
    let traceId = getClientId();
    fetch(plink + service.get_public_key+ appid, { 
        headers: new Headers({
            'Content-Type': 'application/json',
            'clientId': gid,
            'clientSecret': getClientSecret(gid, appid),  
            'X-Trace-Id': traceId,  
            'X-Client-APP':buildClientHeader(),
        })
    })
        .then(response => {
            if (response.status === 200 || response.status === 201) {
                response.json().then(json => actionCallback(json, "success"))
            }
            else if (response.status === 422) {
                localStorage.setItem('RLD' , 'T')
            } else {
                response.json().then(json => actionCallback(json, "Error"))
            }
        })
}


// WEBPACK FOOTER //
// ./src/services/components/public_key.jsx